import React from "react";
import { cn } from "../../lib/utils";

const Container = ({ className, children, ...props }) => {
  return (
    <div
      className={cn("mx-auto max-w-7xl px-6 sm:px-8 lg:px-12", className)}
      {...props}
    >
      {children}
    </div>
  );
};

export { Container };
